import styled from 'styled-components';

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.25rem;
  margin-top: 1.25rem;
  align-items: stretch;
  @media (max-width: 48rem) {
    display: flex;
    flex-direction: column;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  display: flex;
  flex-direction: column;
`;

export const CardTitle = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 10px;
  line-height: 1.4;
  media (max-width: 48rem) {
    font-size: 1.5rem;
  }
`;

export const CardContent = styled.p`
  font-size: 1.3rem;
  flex-grow: 1;
  media (max-width: 48rem) {
    font-size: 1.1rem;
  }
`;

export const NavPills = styled.ul`
  display: flex;
  justify-content: space-around;
  list-style: none;
  padding: 0;
  margin-bottom: 20px;
  gap: 0.625rem;

  li {
    flex: 1;
    text-align: center;
    cursor: pointer;
    padding: 0.625rem 1rem;
    border-radius: 6px;
    transition:
      background 0.3s,
      color 0.3s;
    background: var(--gray-decent);

    &.active {
      background: var(--brand-primary);
      color: white;
      font-weight: bold;
    }
  }

  @media (max-width: 48rem) {
    flex-direction: column;
    li {
      width: 100%;
    }
  }
`;
